import morecurrency from "./morecurrency.js";
import crosschain from "./crosschain.js";

export default {
  morecurrency,
  crosschain,
};
